module.exports = {"cta":{"labels":{"loading":"Composant CTA en cours de préparation","isActiveCampaignUnilingual":"Active Campaign est identique pour toutes les langues","isActiveCampaign":"Je désire un Active Campaign au lieu d'un lien","activeCampaignId":"Active campaign: Simple Embed","name":"Texte bouton","link":"Lien"}}}


//////////////////
// WEBPACK FOOTER
// ./components/Custom/Cta/admin-fr.json
// module id = AGVc
// module chunks = 18